export default __webpack_public_path__ + "static/media/diamond.a541d1a4.svg";